import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    isLoading: false,
    isSessionEnded: false,
    hasDropdownError: false,
}

const UISlice = createSlice({
    name: 'UISlice',
    initialState,
    reducers: {
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        setIsSessionEnded(state, action) {
            state.isSessionEnded = action.payload;
        },
        setHasDropdownError(state, action) {
            state.hasDropdownError = action.payload;
        },
    },
});

const {actions, reducer: UIReducer} = UISlice;

const UIActions = {
    ...actions,
}

export {
    UIActions,
    UIReducer,
}
